import "@fontsource/rubik/400.css"
import "@fontsource/rubik/600.css"
import "@fontsource/rubik/700.css"
import "@fontsource/rubik/800.css"
import cx from "classnames"
import {FC} from "react"

export const StaticPage: FC<{title: string}> = ({title, children}) => {
  return (
    <div
      className={cx(
        "h-full",
        "overflow-auto",
        "bg-[url(/images/pattern@2x.png)]",
        "bg-[length:862px_762px]",
      )}
    >
      <div className={cx("max-w-[500px]", "mx-auto", "my-20", "space-y-6")}>
        <h1 className={cx("font-heading", "text-5xl", "font-semibold")}>
          {title}
        </h1>

        {children}
      </div>
    </div>
  )
}
